import { api, guard, unwrap } from './client'

/**
 * The user's connected GitHub account.
 *
 * `connect` returns a URL rather than performing a redirect, because the browser has to
 * *leave* for github.com — the credential is exchanged server to server on the way back, so
 * the access token never passes through this page.
 */
export const integrationsApi = {
  status: () => guard(async () => unwrap(await api.GET('/api/integrations/github'))),

  connect: (redirectTo?: string) =>
    guard(async () =>
      unwrap(
        await api.POST('/api/integrations/github/connect', {
          params: { query: redirectTo ? { redirect_to: redirectTo } : {} },
        }),
      ),
    ),

  disconnect: () => guard(async () => unwrap(await api.DELETE('/api/integrations/github'))),
}
